import createLucideIcon from '../createLucideIcon';

const LayoutDashboard = createLucideIcon('LayoutDashboard', [
  ['rect', { width: '7', height: '9', x: '3', y: '3', key: 'zk03n7' }],
  ['rect', { width: '7', height: '5', x: '14', y: '3', key: '64exd5' }],
  ['rect', { width: '7', height: '9', x: '14', y: '12', key: '1pvn9' }],
  ['rect', { width: '7', height: '5', x: '3', y: '16', key: '1bensd' }],
]);

export default LayoutDashboard;
